/* HeaderLozenges.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Lozenge from '@atlaskit/lozenge';
import RichTooltip from '../../../../primitives/RichTooltip';
import { TEST_IDS } from '../../../../primitives/testIds';
import { LozengeList } from './HeaderLozenges.styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "@keyframes k12bvu9r{0%{max-height:0}to{max-height:2rem}}";
const _4 = "._kqswh2mm{position:relative}";
const _3 = "._y44v1bgx{animation:k12bvu9r .5s ease-in-out}";
const _2 = "._18m915vq{overflow-y:hidden}";
const _ = "._1reo15vq{overflow-x:hidden}";
const heightReveal = null;
export const AnimatedList = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "li",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1reo15vq _18m915vq _y44v1bgx _kqswh2mm", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AnimatedList.displayName = 'AnimatedList';
}
export const HeaderLozengeItem = _ref2 => {
  let {
    lozenge
  } = _ref2;
  const {
    label,
    isBold = false,
    appearance = 'default',
    tooltipContent = null
  } = lozenge;
  const ListItem = !window.__INITIAL_STATE__ ? AnimatedList : 'li';
  const lozengeContent = /*#__PURE__*/_jsx(Lozenge, {
    appearance: appearance,
    isBold: isBold,
    children: label
  });
  if (tooltipContent) {
    return /*#__PURE__*/_jsx(ListItem, {
      children: /*#__PURE__*/_jsx(RichTooltip, {
        content: tooltipContent,
        children: lozengeContent
      })
    }, label);
  }
  return /*#__PURE__*/_jsx(ListItem, {
    children: lozengeContent
  }, label);
};
const HeaderLozenges = _ref3 => {
  let {
    lozenges
  } = _ref3;
  if (!lozenges.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(LozengeList, {
    "data-testid": TEST_IDS.APP_HEADER_LOZENGES,
    children: lozenges.map(lozenge => /*#__PURE__*/_jsx(HeaderLozengeItem, {
      lozenge: lozenge
    }, lozenge.label))
  });
};
export default HeaderLozenges;